module.exports = "query GetCampaign($id: ID!) {\n  campaign(id: $id) {\n    ...CampaignFragment\n  }\n}\n"